let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8aCmK")).then(() => parcelRequire('lLQGg'));